// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__cAlbN","inner":"Footer_inner__2VFpj","copyright":"Footer_copyright__1T-9L"};